export default
[
    {
        name: 'Object_0',
        type: 'gltfModel',
        path: '/models/Object_0.glb'
    },
    {
        name: 'Object_1',
        type: 'gltfModel',
        path: '/models/Object_1.glb'
    },
    {
        name: 'Object_2',
        type: 'gltfModel',
        path: '/models/Object_2.glb'
    },
    {
        name: 'Object_3',
        type: 'gltfModel',
        path: '/models/Object_3.glb'
    },
    {
        name: 'Particle_0',
        type: 'gltfModel',
        path: '/models/Particle_0.glb'
    },
    {
        name: 'Particle_2',
        type: 'gltfModel',
        path: '/models/Particle_2.glb'
    },
    {
        name: 'WhireCube_00',
        type: 'gltfModel',
        path: '/models/WhireCube_00.glb'
    },
    {
        name: 'WhireCube_01',
        type: 'gltfModel',
        path: '/models/WhireCube_01.glb'
    },
    {
        name: 'WhireCube_Texture',
        type: 'texture',
        path: '/images/WhireCube_Texture.png'
    }
]